import React from 'react';
import { ArcCheckbox, ArcStack, ArcText } from '@src/core/ui';
import { AGREEMENT_TEXT } from '../../constants';
import { ChecklistAgreementProps } from './types';

const ChecklistAgreement: React.FC<ChecklistAgreementProps> = ({ checked, onToggle }) => {
  return (
    <ArcStack direction='row' alignItems='center'>
      <ArcCheckbox
        size='small'
        color='brand'
        checked={checked}
        onChange={onToggle}
      />
      <ArcText.caption 
        fontSize={12} 
        color='text.primary' 
        fontWeight={500}>
        {AGREEMENT_TEXT}
      </ArcText.caption>
    </ArcStack>
  );
};

export default ChecklistAgreement;

